import React, {Fragment, useState} from 'react'
import useAdmin from 'admin/hooks/useAdmin'
import useHistory from 'admin/hooks/useHistory'
import InputField from 'admin/components/shared/InputField'
import Header from '../shared/Header'
import ColumnView from './ColumnView'
import RowView from './RowView'

export default ({itemType, itemId, title, allowNotes = false, className}) => {
  const [notes, setNotes] = useState('')
  const {history, loading, update: updateHistory} = useHistory(itemType, itemId)
  const {admin, update: updateAdmin} = useAdmin()

  const handleViewSwitch = e => {
    e.preventDefault()
    const newView = admin.preferences.historyView === 'row' ? 'column' : 'row'
    updateAdmin({preferences: {...admin.preferences, historyView: newView}})
  }

  const handleChange = ({notes}) => {
    setNotes(notes)
  }

  const handleUpdate = e => {
    e.preventDefault()
    if (notes.length) {
      updateHistory({notes}, () => setNotes(''))
    }
  }

  if (!itemId) return null

  return (
    <Fragment>
      <Header title={title || `History${allowNotes ? ' & Notes' : ''}`}>
        <button className='button is-dark' onClick={handleViewSwitch}>
          <span className='icon is-small'>
            <i
              className={`fa fa-${admin.preferences?.historyView === 'row' ? 'table-list' : 'table-columns'}`}
              aria-hidden='true'></i>
          </span>
        </button>
      </Header>
      <section className={`section is-narrow ${className || ''}`}>
        <div className='container'>
          {allowNotes && (
            <form className='mb-2'>
              <InputField
                value={notes}
                type='textarea'
                name='notes'
                showLabel={false}
                onChange={handleChange}
                rows={2}
              />
              <button onClick={handleUpdate} className='button is-primary is-right is-small has-text-weight-semibold'>
                Add note
              </button>
            </form>
          )}
          {loading ? (
            <p className='mb-0'>Loading...</p>
          ) : !history.length ? (
            <p className='mb-0'>There is no history.</p>
          ) : admin.preferences?.historyView === 'row' ? (
            <RowView history={history} />
          ) : (
            <ColumnView history={history} />
          )}
        </div>
      </section>
    </Fragment>
  )
}
